// extracted by mini-css-extract-plugin
export default {"container":"VirtualList_container__RmAoA","containerHidden":"VirtualList_containerHidden__FkuIx","list":"VirtualList_list__oVLJ+"};